import React, { useMemo } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import FormHeading from "./FormHeading";
import { WEB_URL } from "../../../api/URLs";
import { DonationMessage } from "./DonationMessage";
import { keepingInTouchValues } from "../../../constants";
import { CheckboxWithLabel, MixPanelTrackedLink } from "../../../components";
import { useSelector } from "react-redux";

function KeepInTouch({ handleCheck, state }) {
    const mapKeepingInTouchOptions = () => {
        return <Stack padding="16px 0">
            {
                keepingInTouchValues.map(value => {
                    return <CheckboxWithLabel label={value.label} nameAndId={value.name} handleCheck={handleCheck} />
                })
            }
        </Stack>
    }
    return <Box>
        <FormHeading heading={"Keeping in touch"} />
        <Typography>
            We’d love to keep you updated on how your support is making a difference in the lives of less privileged children across Pakistan.
            We will send you information about our work, campaigns, events and other ways you can support TCF.
            Simply let us know how you would like to hear from us:
        </Typography>
        {mapKeepingInTouchOptions()}
        <Typography>
            Taking care of your information is really important to us. We promise to keep your details safe and secure.
        </Typography>
        <br />
        <Typography>
            You can withdraw your consent at any time. To change your preferences or opt out of receiving communications, please contact us at <a href="mailto:contact@tcfglobal.org">contact@tcfglobal.org</a>. For full details on how your data is used and stored, please see our Privacy Policy at
            <MixPanelTrackedLink
                type="link"
                label={window.location.host + WEB_URL.PRIVACY_POLICY}
                href={WEB_URL.PRIVACY_POLICY}
                // sx={{ display: 'inline-flex' }}
                context="Privacy policy link on 'Keep In Touch' section of checkout page"
                underline="none">
                &nbsp;{window.location.host + WEB_URL.PRIVACY_POLICY}
            </MixPanelTrackedLink>
        </Typography>
        <DonationMessage showMessageTextArea={state.leaveAMessageWithDonation} handleInputChange={handleCheck} />
    </Box>
}

export default function({ handleCheck }) {
    const state = useSelector(state => state.donationCheckout);

    return useMemo(() => {
        return <KeepInTouch handleCheck={handleCheck} state={state} />
    }, [state.leaveAMessageWithDonation])
}